import { useFlags } from 'launchdarkly-react-client-sdk';
import { useWipeDeviceMutation as useWipeDeviceMdmMutation } from '@/redux/slices/mdmManagementApiSlice';
import { useWipeDeviceMutation as useWipeDeviceCoreEntityMutation } from '@/redux/slices/deviceApiSlice';
import { WipeArgs } from '@/types/mdmManagement';

export const useWipeDeviceCompat = () => {
  const { byoMdmLockAndWipe } = useFlags();
  const [wipeDeviceMdm, mdmState] = useWipeDeviceMdmMutation();
  const [wipeDeviceCoreEntity, coreEntityState] =
    useWipeDeviceCoreEntityMutation();

  const wipeDevice = (args: WipeArgs) =>
    byoMdmLockAndWipe ? wipeDeviceCoreEntity(args) : wipeDeviceMdm(args);

  return [wipeDevice, byoMdmLockAndWipe ? coreEntityState : mdmState] as const;
};
